/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Rule effects */
export enum RuleEffect {
  Allow,
  Deny,
  AuditOnly,
  RequireApproval,
  RequireMfa,
  RequireJustification,
}

export type RuleEffectArgs = RuleEffect;

export function getRuleEffectEncoder(): FixedSizeEncoder<RuleEffectArgs> {
  return getEnumEncoder(RuleEffect);
}

export function getRuleEffectDecoder(): FixedSizeDecoder<RuleEffect> {
  return getEnumDecoder(RuleEffect);
}

export function getRuleEffectCodec(): FixedSizeCodec<
  RuleEffectArgs,
  RuleEffect
> {
  return combineCodec(getRuleEffectEncoder(), getRuleEffectDecoder());
}
